import React from "react";
import Login from "../LogIn/LogIn";

import { Container } from "react-bootstrap";

const Landing = () => {
  return (
    <>
      <Container
        className=""
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          height: "990px",
          width: "750px",
          marginBottom: "250px",
          marginTop: "250px",
          paddingBottom: "100px",
          alignContent: "center",
          justifyContent: "center",
          backgroundColor: " rgba(6, 154, 183, 0.67)",
          border: "5px solid rgba(4, 142, 183, 0.84)",
          borderRadius: "25px 0px 25px 0px",
        }}
      >
        <div>
          <h1
            style={{
              fontFamily: "sans-serif",
              fontStyle: "oblique",
              fontWeight: "bold",
              fontSize: "69px",
              textAlign: "center",
              textShadow: "2px 2px 5px rgb(12, 111, 150)",
              color: "#ffff",
            }}
          >
            SPAR Hub
          </h1>

          <Login />
        </div>
      </Container>
    </>
  );
};

export default Landing;
